import { HubContactActionTypes, FetchHubContact } from '../actions/HubContactActions';
import { getFetchHubContactRequestStatus } from '../selectors/RequestStatusSelector';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import isHubContact from '../api/HubContactApi';
import requestEntity from './requestEntity';
import RequestEpicDescriptor from './RequestEpicDescriptor';
const fetchFetchHubContact = requestEntity(new RequestEpicDescriptor({
  apiFunction: isHubContact,
  initiatingActionType: HubContactActionTypes.LOAD_IS_HUB_CONTACT,
  requestStatusSelector: getFetchHubContactRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestActions: FetchHubContact
}));
export default fetchFetchHubContact;